var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOngoingSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "support-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6117 7.67136C10.7341 6.44428 11.1633 5.26772 11.8596 4.24999C12.5559 3.23225 13.4971 2.40604 14.5965 1.8474C15.6958 1.28876 16.9181 1.01565 18.1508 1.05322C19.3833 1.09078 20.5866 1.4378 21.6499 2.06234C22.7132 2.68689 23.6023 3.56888 24.2354 4.62714C24.8685 5.68539 25.2252 6.88589 25.2727 8.11814C25.3201 9.35039 25.057 10.5748 24.5072 11.6786C23.9678 12.7617 23.1695 13.6945 22.1836 14.3947",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6152 4.69385C12.7529 5.86835 14.1152 6.80205 15.621 7.4394C17.1268 8.07675 18.7455 8.40474 20.3807 8.40385C21.9889 8.40544 23.5811 8.08876 25.0657 7.47248",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.3525 13.6538C15.9373 13.6538 15.5313 13.777 15.1859 14.0078C14.8405 14.2385 14.5714 14.5665 14.4124 14.9502C14.2535 15.3338 14.2119 15.7561 14.2929 16.1635C14.3739 16.5709 14.5739 16.9451 14.8676 17.2387C15.1613 17.5324 15.5355 17.7325 15.9429 17.8135C16.3503 17.8944 16.7725 17.8529 17.1562 17.694C17.54 17.5351 17.8679 17.2658 18.0986 16.9205C18.3294 16.5752 18.4525 16.1691 18.4525 15.7538C18.4525 15.1969 18.2313 14.6627 17.8375 14.2689C17.4437 13.8751 16.9096 13.6538 16.3525 13.6538Z",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.95251 10.0444V11.5536C7.95251 12.6675 8.39501 13.7358 9.18267 14.5235C9.97032 15.3111 11.0386 15.7537 12.1525 15.7537H14.1451",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.5807 32.5539C31.5808 30.0571 30.8954 27.6084 29.5993 25.4745C28.3085 23.3492 26.4613 21.6174 24.2576 20.4663",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.28027 32.5536C4.27999 30.0571 4.96496 27.6087 6.2605 25.4747C7.54958 23.3514 9.39397 21.6207 11.5943 20.4692",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoingSupport);
export default __webpack_public_path__ + "static/media/ongoing-support.0ec60da31a2b6fa3517da656f07f0e49.svg";
export { ForwardRef as ReactComponent };